<template>
  <div class="banner-content" :class="{center: center}">

    <h1 v-if="!home" id="banner-title">{{title}}</h1>
    <router-link
    v-if="home"
    :to="`/projects/${slug}`"
    tag="h1"
    id="banner-title"
    class="banner-link">{{title}}</router-link>

    <div class="banner-info">
      <h4 v-if="client === 'Personal'">Personal <span>{{type}}</span> project done in <span>{{year}}</span></h4>
      <h4 v-else-if="client === 'Confidential'"><span>{{type}}</span> project for a confidential client done in <span>{{year}}</span></h4>
      <h4 v-else><span>{{type}}</span> project for <span>{{client}}</span> done in <span>{{year}}</span></h4>

      <div class="line" :style="{backgroundColor: color}"></div>
      <p>{{brief}}</p>
    </div>

  </div>
</template>

<script>
export default {

  data () {
    return {

    }
  },
  props: ['title', 'type', 'client', 'year', 'brief', 'color', 'center', 'home', 'slug']

}

</script>

<style lang="scss" scoped>

.center {
  h1 {text-align: center;}

  .banner-info {
    text-align: center;
    margin: 0 auto;

    h4 {
      text-align: center;
      margin: 0 auto;
    }

    p {
      margin: 1rem auto 0 auto;
      max-width: 500px;
    }

    .line {
      margin: 20px auto 0 auto;
    }
  }
}

h1 {
  font-family: $title-font;
  font-size: 2.5rem;
  letter-spacing: -0.07rem;
  color: $gray7;
  position: relative;
  line-height: 100%;
  margin-bottom: 1rem;

  @include tablet-only {font-size: 2.5rem;}
  @include phone-only {font-size: 2rem;}
  @include desktop-only {white-space: pre;}

}

.banner-content {
  width: 100%;
  height: 100%;
  padding: $grid-gap;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.banner-link {
  text-decoration: none;
  transition: color 200ms ease-out;
  @extend %linkify;

  &:hover {
    color: $gray5;
  }
}

.banner-info {
  max-width: 900px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h4 {
    color: $gray4;

    span {
      color: $gray7;
    }
  }

  .line {
    width: 40px;
    height: 3px;
    margin-top: 20px;
    transform-origin: left;
  }

  p {
    color: $gray5;
    margin-top: 1rem;
    max-width: 480px;

    @include tablet-below {
      max-width: 620px;
    }
  }

}

</style>
